import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { useStartNewConversation } from 'hooks/useStartNewConversation'

import { useIsPanelOpen } from 'stores/usePanelsStateStore'

import { cn } from 'utils/cn'

import { DesktopHeader } from './components/DesktopHeader'
import { HeaderWrapper } from './components/HeaderWrapper'
import { MobileHeader } from './components/MobileHeader'
import { MobileMenuButton } from './components/MobileMenuButton'
import { UserMenu } from './components/UserMenu'
import { useConversationTitle } from './components/hooks/useConversationTitle'

export const Header = () => {
  const conversationTitle = useConversationTitle()
  const { handleClickNewConversation } = useStartNewConversation<HTMLButtonElement>()
  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')

  const hasNewConversationButton = Boolean(conversationTitle)

  return (
    <HeaderWrapper>
      <DesktopHeader title={(
        conversationTitle && (
          <h1
            className={cn(
              'w-full flex justify-center max-w-3xl truncate text-base font-medium transition',
              {
                'xl:translate-x-[85px]': isConversationMenuPanelOpen,
                'xl:-translate-x-[25px]': !isConversationMenuPanelOpen,
              },
            )}
          >
            {conversationTitle}
          </h1>
        )
      )}
      >
        <UserMenu />
      </DesktopHeader>
      <MobileHeader
        menu={<MobileMenuButton />}
        title={conversationTitle}
      >
        {hasNewConversationButton && (
          <span className="mr-2">
            <Button onClick={handleClickNewConversation} isSmall icon={faPlus} />
          </span>
        )}
        <UserMenu />
      </MobileHeader>
    </HeaderWrapper>
  )
}
